<div class="content">
  <swiper
    [pagination]="true"
    class="carousel-swiper"
    [autoplay]="{
      delay: 5000,
      disableOnInteraction: false
    }"
  >
    <ng-template swiperSlide *ngFor="let c of carousels">
      <div
        class="image"
        [ngStyle]="{
          'background-image': 'url(' + c.cover + ')'
        }"
        (click)="click(c)"
      ></div>
    </ng-template>
  </swiper>
</div>
